<div class="main-filter-container">

    <div class="box-filter ly-sp-s-bottom">
        <!-- Main flex container -->
        <div class="d-flex flex-row flex-wrap flex-fill">
            <!-- filterSelectContainer -->
            <div class="filter-select d-flex align-items-center gap-2"
                 [ngClass]="{
                     'flex-full mb-2': isSmallSize,
                     'flex-left': isMediumSize || isLargeSize
                 }">
                <ng-container #filterSelectContainer></ng-container>
            </div>
    
            <!-- Container for filterTextContainer and filterWindowContainer -->
            <div class="d-flex gap-2 align-items-center"
                 [ngClass]="{
                     'flex-full-wrapper': isSmallSize,
                     'flex-right': isMediumSize || isLargeSize
                 }">
                <!-- filterTextContainer -->
                <div class="filter-text" 
                     [ngClass]="{
                         'flex-full': isSmallSize,
                         'flex-mid': isMediumSize || isLargeSize
                     }">
                    <ng-container #filterTextContainer></ng-container>
                </div>
    
                <!-- filterWindowContainer -->
                <div class="filter-window">
                    <ng-container #filterWindowContainer></ng-container>
                </div>
            </div>
        </div>
    </div>

    <!-- contextos -->
    <div class="d-flex flex-column">
        <!-- contexto filter window -->
        <div class="main-context-wrapper p-2 context-wrapper d-flex align-items-center" *ngIf="this.areSelectedAdnsChecked()">
            <div *ngFor="let selectedAdn of this.selectedAdns; let adnListIndex=index;" class="d-flex flex-wrap text-center align-items-center">
                <div *ngFor="let individualAdn of selectedAdn.ArrayEntities.List">
                    <div *ngIf="individualAdn.Value !== 'N' && individualAdn.Value !== null" class="filtered-values-wrapper context-wrapper d-flex align-items-center justify-content-center me-1 ms-2">
                        <div class="filterd-value-title h-100">
                            {{individualAdn.Display}}
                        </div>
                        <div class="filterd-value-icon h-100" (click)="cleanSingleFilter(individualAdn, adnListIndex)">
                            <img src="assets/imgs/cancel-icon.png" class="filter-btn-img">
                        </div>
                    </div>
                </div>
           </div> 
           <div class="delete-filters-wrapper">
            <div class="d-flex justify-content-start align-items-center delete-filters-wrapper" (click)="cleanAllFilters()">
                <p class="mb-0 me-2">Borrar filtros</p>
                <i class="fa fa-trash"></i>
            </div>
           </div>
        </div>

        <!-- contexto ctTextFilter -->
        <div class="main-context-wrapper p-3 context-wrapper d-flex align-items-center"
            *ngIf="this.currentTextFilters.length > 0">
            <img src="assets/imgs/search-icon.png" class="search-btn-img text-filter-context">
            <div class="me-1">Resultados de búsqueda para:</div>
            <div *ngFor="let text of this.currentTextFilters; let i = index">
                <div class="fw-bold"> <span *ngIf="i!==0">, </span>{{text}}</div>
            </div>
        </div>

    </div>
</div>
